// Translator notes: Numbers and collectives (engine/src/numbers.ts), comparison and relative clauses (comparison.ts,
// relatives.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  countedCollective: {
    args: ['word', 'hv'],
    fi: (a: string[]) => `”${a[0]}” laskettiin sanalla ${a[1]} monikossa, sillä lukusanan jälkeen tulee monikko eikä kollektiivi (oppitunti 25).`,
    en: (a: string[]) => `“${a[0]}” was counted with ${a[1]} in the plural: a numeral takes the plural, not the collective (lesson 25).`,
  },
  numberAgreement: {
    args: [],
    fi: () => 'Kollektiivi saa verbin yksikköön ja muutama (paukaali) monikkoon, samoin niiden adjektiivit (oppitunnit 28 ja 35).',
    en: () => 'A collective takes a singular verb and a paucal a plural one; their adjectives follow the same rule (lessons 28 and 35).',
  },
  ageFromHv: {
    args: [],
    fi: () => 'Ikä: valyriaksi sanotaan ”on nähnyt N vuotta” (verbin urnegon perfekti ja kollektiivi jēdari), suomeksi ”on N vuotta vanha” (oppitunti 25).',
    en: () => 'Age: High Valyrian says “has seen N years” (the perfect of urnegon with the collective jēdari); English says “is N years old” (lesson 25).',
  },
  howEquative: {
    args: [],
    fi: () => '”Kuinka pitkä …?” on valyriaksi hae skorot ja adjektiivin ekvatiivi (”Hae skorot vala bōsāpa issa?” = kuinka pitkä mies on?, oppitunti 48).',
    en: () => '“How tall …?” is hae skorot with the equative of the adjective (“Hae skorot vala bōsāpa issa?” = how tall is the man?, lesson 48).',
  },
  moreThan: {
    args: [],
    fi: () => '”Enemmän kuin” verbin yhteydessä: vertailukohta genetiivissä ja sen perässä toliot (”aō toliot” = enemmän kuin sinua, oppitunti 48).',
    en: () => '“More than” with a verb: the standard in the genitive followed by toliot (“aō toliot” = more than you, lesson 48).',
  },
  bareEquative: {
    args: [],
    fi: () => '”Hiljainen kuin varjo”: vertailukohta instrumentaalissa ja adjektiivi ekvatiivissa (”Sȳndroso lykāpa”, oppitunti 48).',
    en: () => '“Quiet as a shadow”: the standard in the instrumental and the adjective in the equative (“Sȳndroso lykāpa”, lesson 48).',
  },
  headlessWhat: {
    args: [],
    fi: () => '”Mitä” lauseen edellä on relatiivipronomini līr, joka tulee lauseensa jälkeen (”Jaelā līr gīmin” = tiedän, mitä haluat, oppitunti 46).',
    en: () => '“What” before a clause is the relative pronoun līr, after its clause (“Jaelā līr gīmin” = I know what you want, lesson 46).',
  },
  verblessRelative: {
    args: [],
    fi: () => '”Joka on X” ilman verbiä: X taipuu relatiivipronominin mukaan (”Ñuhor līr” = se, mikä on minun, oppitunti 46).',
    en: () => '“Which is X” has no verb: X agrees with the relative pronoun (“Ñuhor līr” = what is mine, lesson 46).',
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
